import { Outlet } from "react-router-dom";
import SideBar from "./SideBar";
import Header from "../layouts/Header";
export default function MainLayout() {
  return (
    <div className="flex h-screen overflow-hidden">
      <SideBar />
      <div className="flex-1 p-2 pt-0 overflow-y-auto overflow-x-hidden bg-[#F5F6FA]">
        {/* <Header className="m-0 p-0" /> */}
        {/* <div className="p-6 flex justify-between items-center">
          <div className="text-[#4B5563]">
            {" "}
            Dashboard • -- • Survey Dashboard
          </div>
        </div> */}

        <Outlet />
      </div>
    </div>
  );
}
